function formatItemcount(value) {
  let locale = 'de';

  switch (true) {
    default:
      break;

    case !!this.context && !!this.context.config && !!this.context.config.language:
      locale = this.context.config.language;
      break;

    case typeof window !== 'undefined' && !!window.swinger && !!window.swinger.config && !!window.swinger.config.language:
      locale = window.swinger.config.language;
      break;
  }

  value = parseInt(value, 10);

  let formatter;
  try {
    formatter = new Intl.NumberFormat(locale, {
      style: 'decimal',
      useGrouping: true,
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  } catch (e) {
    formatter = {
      format: (value) => value,
    };
  }

  if (value >= 10000) {
    return `${formatter.format(10000)}+`;
  }

  return formatter.format(parseInt(value, 10));
}

module.exports = formatItemcount;



// WEBPACK FOOTER //
// ./src/libs/twig/format_itemcount/index.js